import { render, staticRenderFns } from "./good-for-you-product.vue?vue&type=template&id=1ddf14e5&scoped=true"
import script from "./good-for-you-product.vue?vue&type=script&lang=js"
export * from "./good-for-you-product.vue?vue&type=script&lang=js"
import style0 from "./good-for-you-product.vue?vue&type=style&index=0&id=1ddf14e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf14e5",
  null
  
)

export default component.exports